import { useInfiniteQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'
import { fetchSessions } from '../api'
import type { SessionsQueryParams } from '../types'

export function useSessionsQuery(
  sessionType: string | null,
  params: SessionsQueryParams = {}
) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useInfiniteQuery({
    queryKey: ['sessions', sessionType, organization?.id, params],
    queryFn: async ({ pageParam }) => {
      const token = await getToken()
      return fetchSessions(token, sessionType, {
        ...params,
        cursor: pageParam as string | undefined,
      })
    },
    getNextPageParam: (lastPage) =>
      lastPage.pagination.next_cursor ?? undefined,
    initialPageParam: undefined as string | undefined,
    staleTime: 5000, // 5 seconds - short staleTime for more responsive filters
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
